<template>
  <!-- TODO: separate pan logic to a separate component -->
  <div @click="handleWheel" id="zoom">
    <GChart
      :settings="{ packages: [ 'orgchart'], callback: createTreeData }"
      :data="treeData"
      version="current"
      :events="treeEvents"
      :options="treeOptions"
      type="OrgChart"
    />
  </div>
</template>

<script>
import {GChart} from 'vue-google-charts'
import AccountCard from './AccountCard'
import Vue from 'vue'

const ComponentClass = Vue.extend(AccountCard)

export default {
  components: {
    GChart
  },
  data () {
    return {
      currentScale: 70,
      authenticatedUser: this.$store.getters['authentication/user'],
      panZoomOptions: {
        bounds: false,
        transformOrigin: {x: 0.5, y: 0.5},
        maxZoom: 1,
        minZoom: 0.4,
        onTouch: () => {
          return false // tells the library to not preventDefault.
        }
      },
      treeData: [['Name', 'Manager']],
      treeOptions: {
        'allowHtml': true,
        'size': 'medium'
      },
      treeEvents: {
        'ready': () => {
          document.querySelectorAll('.account_card_invite').forEach(ele => {
            ele.addEventListener('click', (e) => {
              this.$store.commit('settings/SUB_ACCOUNT_INVITE_POPUP', {
                display: true,
                id: e.target.getAttribute('data-id')
              })
            })
          })

          document.querySelectorAll('.go-to-sub-account-details').forEach(ele => {
            ele.addEventListener('click', (e) => {
              this.$router.push({name: 'subaccount-details', params: {id: e.target.getAttribute('data-id')}})
            })
          })

          // TODO handle/remove try catch
          document.querySelectorAll('.resend-invitation').forEach((ele) => {
            ele.addEventListener('click', async (e) => {
              try {
                await this.$store.dispatch('settings/reSendInvitations', {
                  id: e.target.getAttribute('data-id')
                })

                this.$emit('resend')
              } catch (e) {
                // catch error
              }
            })
          })
        }
      }
    }
  },
  async mounted () {
    await this.$store.dispatch('settings/members')

    this.createTreeData()
  },
  computed: {
    users () {
      const users = this.$store.getters['settings/accounts']

      this.$emit('noInvites', !users.length)
      return users
    }
  },
  methods: {
    handleWheel () {
      const self = this
      const zoomSection = document.getElementById('zoom')

      let defaultScale = 70
      const currentScale = zoomSection.style.transform.match(/\d+(\.\d+)?/)

      if (currentScale) {
        defaultScale = Number(currentScale[0])
      }

      this.currentScale = defaultScale

      window.addEventListener('wheel', function (event) {
        if (event.deltaY < 0) { //minimize
          self.zoomOut('zoom')
        } else if (event.deltaY > 0) { //maxmize
          self.zoomIn('zoom')
        }
      })
    },

    zoomIn (DOMID, stepPercentage = 5, maxPercentage = 100) {
      if (this.currentScale < maxPercentage) {
        this.currentScale += stepPercentage
      }

      this.setScale(DOMID, this.currentScale)
    },

    zoomOut (DOMID, stepPercentage = 5, minPercentage = 30) {
      if (this.currentScale > minPercentage) {
        this.currentScale -= stepPercentage
      }

      this.setScale(DOMID, this.currentScale)
    },

    setScale (DOMID, scaleValue) {
      document.getElementById(DOMID).style.transform = `scale(${scaleValue}%)`
    },

    getCardData (user) {
      const isSameAsActiveUser = this.isSameAsActiveUser(user)

      const cardData = new ComponentClass({
        propsData: {
          name: user.name.trimLeft(),
          avatar: user.user && user.user.length && user.user[0].media.length ? user.user[0].media[0].url : require('@/assets/images/pages/default-avatar.png'),
          email: user.email,
          accountsNum: user.children_count,
          invitationStatus: user.invitation_status,
          id: user.id,
          parentId: user.parent_id,
          showParent: !isSameAsActiveUser,
          isBlocked: user.blocked
        }
      })

      cardData.$mount()

      return [
        {
          'v': user.id.toString(),
          'f': cardData.$el.innerHTML
        },
        (isSameAsActiveUser || !user.parent_id) ? '' : user.parent_id.toString()
      ]
    },

    onInitPanZoom (panzoomInstance) {
      panzoomInstance.zoomAbs(0, 0, 0.7)
    },

    isSameAsActiveUser (user) {
      return user.id.toString() === localStorage.getItem('activeAccountId')
    },

    createTreeData () {
      const treeData = [['Name', 'Manager']]

      for (let i = 0; i < this.users.length; i++) {
        const treeRow = this.getCardData(this.users[i])
        treeData.push(treeRow)
      }

      this.treeData = treeData
    }
  }
}
</script>

<style lang="scss">

#zoom {
  transform: scale(70%);
}

.google-visualization-orgchart-node {
  width: 310px !important;
}

.google-visualization-orgchart-node-medium {
  background: #fff;
  box-shadow: 0 4px 12px rgba(189, 189, 189, 0.25);
  border-radius: 6px;
  width: 306px !important;
  border: 1px solid white;
}

.card-subaccounts button {
  position: absolute;
  top: 93%;
  left: 25%;
  background: #0092d7;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: white;
  font-weight: bold;
  font-size: 14px;
  cursor: pointer;
}

.card-subaccounts button::after {
  content: ' \002B';
}

.card-name {
  font-style: normal;
  font-weight: 500;
  float: left;
  font-size: 14px;
  line-height: 27px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

.card-email {
  font-style: normal;
  font-weight: normal;
  float: left;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.107143px;
  color: #2c2c2c;
}

.card-subaccounts {
  font-style: normal;
  font-weight: normal;
  float: left;
  font-size: 12px;
  line-height: 18px;
  letter-spacing: 0.107143px;
  color: rgba(44, 44, 44, 0.4);
}
</style>
